import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row w-100 overflow-hidden" }
const _hoisted_2 = { class: "d-flex flex-column justify-content-center" }
const _hoisted_3 = { class: "required fs-6 fw-semobold mb-2 mt-4" }
const _hoisted_4 = { class: "required fs-6 fw-semobold mb-2 mt-4" }

import SimpleForm from "@/components/SimpleForm.vue";
import { ref } from "vue";
import { Search } from "@element-plus/icons-vue";
import AccountService from "@/projects/tenant/modules/accounts/services/AccountService";
import { AccountRoleTypes } from "@/core/types/AccountInfos";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import UserService from "../../services/UserService";

export default /*#__PURE__*/_defineComponent({
  __name: 'AssignToSalesModal',
  emits: ["assign-success"],
  setup(__props, { expose: __expose, emit: emits }) {

const modalRef = ref<any>();
const isLoading = ref(true);
const selectedLead = ref({} as any);
const salesGroupName = ref(null);
const assignedSalesAccount = ref({} as any);



const clearNewSalesAccount = () => {
  assignedSalesAccount.value = {} as any;
  salesGroupName.value = null;
};

const fetchData = async () => {
  if (salesGroupName.value === null || salesGroupName.value === "") {
    clearNewSalesAccount();
    return;
  }
  isLoading.value = true;
  try {
    const res = await AccountService.queryAccounts({
      role: AccountRoleTypes.Sales,
      code: salesGroupName.value,
    });
    if (res.data.length === 0) {
      MsgPrompt.error("Sales account not found");
    } else {
      assignedSalesAccount.value = res.data[0];
    }
  } catch (e) {
    MsgPrompt.error(e);
  } finally {
    isLoading.value = false;
  }
};

const submit = async () => {
  if (assignedSalesAccount.value.id === undefined) {
    MsgPrompt.error("Please specify a sales account");
    return;
  }
  try {
    isLoading.value = true;
    await UserService.assignLeadToSalesAccount(
      selectedLead.value.id,
      assignedSalesAccount.value.uid
    );
    MsgPrompt.success("Assign success!").then(() => {
      emits("assign-success");
      modalRef.value.hide();
    });
  } catch (err) {
    MsgPrompt.error(err);
    return;
  } finally {
    isLoading.value = false;
  }
};

const show = (_lead) => {
  isLoading.value = true;
  modalRef.value.show();
  selectedLead.value = _lead;
  isLoading.value = false;
};

__expose({
  show,
  hide: () => {
    modalRef.value.hide();
  },
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (_openBlock(), _createBlock(SimpleForm, {
    ref_key: "modalRef",
    ref: modalRef,
    title: _ctx.$t('title.assignSales'),
    "is-loading": isLoading.value,
    submit: submit,
    width: 300
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t("fields.salesCode")), 1),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  class: "w-100",
                  clearable: "",
                  modelValue: salesGroupName.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((salesGroupName).value = $event)),
                  disabled: isLoading.value,
                  onBlur: fetchData,
                  onKeydown: _withKeys(fetchData, ["enter"])
                }, {
                  append: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      icon: _unref(Search),
                      onClick: fetchData
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled", "onKeydown"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t("fields.salesInfo")), 1),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  disabled: "",
                  modelValue: assignedSalesAccount.value.name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((assignedSalesAccount.value.name) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "is-loading"]))
}
}

})